import { MarkFavoritePersonaNodeAsAddedState } from './actions/v1/people/markFavoritePersonaNodeAsAdded';
import { OnFavoritePersonaSelectedState } from './actions/v1/people/onFavoritePersonaSelected';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { Folder } from 'owa-folders';
import FolderType from 'owa-service/lib/contract/Folder';
import PersonaType from 'owa-service/lib/contract/PersonaType';

import { FavoritePersonaNode } from 'owa-favorites-types';

// Import orchestrators so they are initialized at the same time as the store
import './orchestrators/migrateOutlookFavoritesOrchestrator';
import './orchestrators/people/onFavoritesLoadedOrchestrator';
import { runAfterBootstrap } from 'owa-delayed-initialization';

import { default as addFavoritePersona } from './actions/addFavoritePersona';

export {
    default as getFavoriteNodeViewStateFromId,
} from './selectors/getFavoriteNodeViewStateFromId';
export { default as FavoriteNodeDragData } from './store/schema/FavoriteNodeDragData';
export { getStore, default as mailFavoritesStore } from './store/store';
export { default as FavoritesViewState } from './store/schema/FavoritesViewState';
export { default as showFindFavoritesPicker } from './actions/showFindFavoritesPicker';
export {
    FavoritePersonaNode,
    Folder,
    FolderType,
    MarkFavoritePersonaNodeAsAddedState,
    OnFavoritePersonaSelectedState,
    PersonaType,
};
export { addFavoritePersona };
export { default as datapoints } from './datapoints';
export {
    default as initializeFavoritePersonas,
} from './actions/v1/people/initializeFavoritePersonas';

export {
    default as outlookFavoritePersonasLoaded,
} from './actions/v2/people/outlookFavoritePersonasLoaded';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailFavoritesStore", webpackPrefetch: true */ './lazyIndex')
);

export let lazyToggleFavoritesTreeExpansion = new LazyAction(
    lazyModule,
    m => m.toggleFavoritesTreeExpansion
);

export let lazyRemoveFavoriteSearch = new LazyAction(lazyModule, m => m.removeFavoriteSearch);
export let lazyRemoveFavoritePersona = new LazyAction(lazyModule, m => m.removeFavoritePersona);

export let lazyOnSelectedPersonaNodeChanged = new LazyAction(
    lazyModule,
    m => m.onSelectedPersonaNodeChanged
);

export let lazyHandleToggleFavoritePersonaError = new LazyAction(
    lazyModule,
    m => m.handleToggleFavoritePersonaError
);

export let lazyMarkFavoritePersonaNodeAsAdded = new LazyAction(
    lazyModule,
    m => m.markFavoritePersonaNodeAsAdded
);

export let lazyOnFavoritePersonaSelected = new LazyAction(
    lazyModule,
    m => m.onFavoritePersonaSelected
);

export let lazyAddFavoriteFolder = new LazyImport(lazyModule, m => m.addFavoriteFolder);
export let lazyRemoveFavoriteFolder = new LazyImport(lazyModule, m => m.removeFavoriteFolder);

export let lazyOnFavoritePersonaUpdated = new LazyAction(
    lazyModule,
    m => m.onFavoritePersonaUpdated
);
export { default as isFavoritingInProgress } from './selectors/isFavoritingInProgress';

runAfterBootstrap(() => {
    lazyModule.import();
});
